// Generated by purs version 0.15.0
import * as Data_Bounded_Generic from "../Data.Bounded.Generic/index.js";
import * as Data_Enum_Generic from "../Data.Enum.Generic/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic_Calendar_Types_RestaurantLocalDay from "../Restaumatic.Calendar.Types.RestaurantLocalDay/index.js";
import * as Restaumatic_Coupons_Types_Id from "../Restaumatic.Coupons.Types.Id/index.js";
import * as Restaumatic_Promotions_Types_Id from "../Restaumatic.Promotions.Types.Id/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var Manual = /* #__PURE__ */ (function () {
    function Manual() {

    };
    Manual.value = new Manual();
    return Manual;
})();
var FirstOrderDiscount = /* #__PURE__ */ (function () {
    function FirstOrderDiscount() {

    };
    FirstOrderDiscount.value = new FirstOrderDiscount();
    return FirstOrderDiscount;
})();
var Loyalty = /* #__PURE__ */ (function () {
    function Loyalty() {

    };
    Loyalty.value = new Loyalty();
    return Loyalty;
})();
var Pbx = /* #__PURE__ */ (function () {
    function Pbx() {

    };
    Pbx.value = new Pbx();
    return Pbx;
})();
var FirstAbsenceReminder = /* #__PURE__ */ (function () {
    function FirstAbsenceReminder() {

    };
    FirstAbsenceReminder.value = new FirstAbsenceReminder();
    return FirstAbsenceReminder;
})();
var SecondAbsenceReminder = /* #__PURE__ */ (function () {
    function SecondAbsenceReminder() {

    };
    SecondAbsenceReminder.value = new SecondAbsenceReminder();
    return SecondAbsenceReminder;
})();
var RosPhoneOrder = /* #__PURE__ */ (function () {
    function RosPhoneOrder() {

    };
    RosPhoneOrder.value = new RosPhoneOrder();
    return RosPhoneOrder;
})();
var RosPortalOrder = /* #__PURE__ */ (function () {
    function RosPortalOrder() {

    };
    RosPortalOrder.value = new RosPortalOrder();
    return RosPortalOrder;
})();
var PromotionIdForSource = function (x) {
    return x;
};
var UsageData = function (x) {
    return x;
};
var CouponInfo = function (x) {
    return x;
};
var newtypeUsageData_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypePromotionIdForSour = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeCouponInfo_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldUsageData = function (dictHasField) {
    return dictHasField;
};
var hasFieldPromotionIdForSou = function (dictHasField) {
    return dictHasField;
};
var hasFieldCouponInfo = function (dictHasField) {
    return dictHasField;
};
var eqCouponSource = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Manual && y instanceof Manual) {
                return true;
            };
            if (x instanceof FirstOrderDiscount && y instanceof FirstOrderDiscount) {
                return true;
            };
            if (x instanceof Loyalty && y instanceof Loyalty) {
                return true;
            };
            if (x instanceof Pbx && y instanceof Pbx) {
                return true;
            };
            if (x instanceof FirstAbsenceReminder && y instanceof FirstAbsenceReminder) {
                return true;
            };
            if (x instanceof SecondAbsenceReminder && y instanceof SecondAbsenceReminder) {
                return true;
            };
            if (x instanceof RosPhoneOrder && y instanceof RosPhoneOrder) {
                return true;
            };
            if (x instanceof RosPortalOrder && y instanceof RosPortalOrder) {
                return true;
            };
            return false;
        };
    }
};
var eqPromotionIdForSource = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Promotions_Types_Id.eqPromotionId))(x.promotionId)(y.promotionId) && Data_Eq.eq(eqCouponSource)(x.source)(y.source);
        };
    }
};
var eqUsageData = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Eq.eqArray(Restaumatic_Coupons_Types_Id.eqCouponId))(x.activeCoupons)(y.activeCoupons) && x.generatedCoupons === y.generatedCoupons && Data_Eq.eq(Data_Eq.eqArray(eqCouponSource))(x.marketing)(y.marketing) && Data_Eq.eq(Restaumatic_Promotions_Types_Id.eqPromotionId)(x.promotionId)(y.promotionId) && x.usedCoupons === y.usedCoupons;
        };
    }
};
var ordCouponSource = {
    compare: function (x) {
        return function (y) {
            if (x instanceof Manual && y instanceof Manual) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Manual) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Manual) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof FirstOrderDiscount && y instanceof FirstOrderDiscount) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof FirstOrderDiscount) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof FirstOrderDiscount) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Loyalty && y instanceof Loyalty) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Loyalty) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Loyalty) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Pbx && y instanceof Pbx) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Pbx) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Pbx) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof FirstAbsenceReminder && y instanceof FirstAbsenceReminder) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof FirstAbsenceReminder) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof FirstAbsenceReminder) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof SecondAbsenceReminder && y instanceof SecondAbsenceReminder) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof SecondAbsenceReminder) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof SecondAbsenceReminder) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof RosPhoneOrder && y instanceof RosPhoneOrder) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof RosPhoneOrder) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof RosPhoneOrder) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof RosPortalOrder && y instanceof RosPortalOrder) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Restaumatic.Coupons.Types (line 83, column 1 - line 83, column 33): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqCouponSource;
    }
};
var eqCouponInfo = {
    eq: function (x) {
        return function (y) {
            return x.code === y.code && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Calendar_Types_RestaurantLocalDay.eqRestaurantLocalDay))(x.expiresOn)(y.expiresOn) && x.promotionName === y.promotionName;
        };
    }
};
var genericUsageData = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericPromotionIdForSource = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericCouponSource = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Manual.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return FirstOrderDiscount.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return Loyalty.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return Pbx.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return FirstAbsenceReminder.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return SecondAbsenceReminder.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
            return RosPhoneOrder.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))))) {
            return RosPortalOrder.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Coupons.Types (line 69, column 1 - line 69, column 79): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Manual) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof FirstOrderDiscount) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Loyalty) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof Pbx) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof FirstAbsenceReminder) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
        };
        if (x instanceof SecondAbsenceReminder) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
        };
        if (x instanceof RosPhoneOrder) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))));
        };
        if (x instanceof RosPortalOrder) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)))))));
        };
        throw new Error("Failed pattern match at Restaumatic.Coupons.Types (line 69, column 1 - line 69, column 79): " + [ x.constructor.name ]);
    }
};
var showCouponSource = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCouponSource)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Manual";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "FirstOrderDiscount";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Loyalty";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Pbx";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "FirstAbsenceReminder";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "SecondAbsenceReminder";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "RosPhoneOrder";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "RosPortalOrder";
        }
    })))))))))
};
var showPromotionIdForSource = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPromotionIdForSource)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "source";
        }
    })(Data_Show.showRecordFieldsNil)(showCouponSource))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Promotions_Types_Id.showPromotionId)))))({
        reflectSymbol: function () {
            return "PromotionIdForSource";
        }
    }))
};
var showUsageData = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericUsageData)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "activeCoupons";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "generatedCoupons";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "marketing";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "usedCoupons";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showInt))(Restaumatic_Promotions_Types_Id.showPromotionId))(/* #__PURE__ */ Data_Show.showArray(showCouponSource)))(Data_Show.showInt))(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Coupons_Types_Id.showCouponId)))))({
        reflectSymbol: function () {
            return "UsageData";
        }
    }))
};
var unscrambleDecodeCouponSource = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericCouponSource)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Manual";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "FirstOrderDiscount";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Loyalty";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Pbx";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "FirstAbsenceReminder";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "SecondAbsenceReminder";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "RosPhoneOrder";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "RosPortalOrder";
        }
    })))))))))(Unscramble_Enum.defaultEnumOptions)
};
var unscrambleDecodePromotionIdForSource = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPromotionIdForSource)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Promotions_Types_Id.decodePromotionId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "source";
        }
    })(unscrambleDecodeCouponSource)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodeUsageData = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericUsageData)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "activeCoupons";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Coupons_Types_Id.unscrambleDecodeCouponId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "generatedCoupons";
        }
    })(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "marketing";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeCouponSource))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(Restaumatic_Promotions_Types_Id.decodePromotionId)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "usedCoupons";
        }
    })(Unscramble.decodeInt1)(Unscramble.decodeRecordNil)))))))))(Unscramble_Generic.defaultOptions)
};
var boundedCouponSource = {
    top: /* #__PURE__ */ Data_Bounded_Generic.genericTop(genericCouponSource)(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))))))))),
    bottom: /* #__PURE__ */ Data_Bounded_Generic.genericBottom(genericCouponSource)(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))),
    Ord0: function () {
        return ordCouponSource;
    }
};
var enumCouponSource = {
    succ: /* #__PURE__ */ Data_Enum_Generic.genericSucc(genericCouponSource)(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments)))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments)))),
    pred: /* #__PURE__ */ Data_Enum_Generic.genericPred(genericCouponSource)(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments)))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments)))),
    Ord0: function () {
        return ordCouponSource;
    }
};
var boundedEnumCouponSource = {
    cardinality: /* #__PURE__ */ Data_Enum_Generic.genericCardinality(genericCouponSource)(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))))))))),
    toEnum: /* #__PURE__ */ Data_Enum_Generic.genericToEnum(genericCouponSource)(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))))))))),
    fromEnum: /* #__PURE__ */ Data_Enum_Generic.genericFromEnum(genericCouponSource)(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))))))))),
    Bounded0: function () {
        return boundedCouponSource;
    },
    Enum1: function () {
        return enumCouponSource;
    }
};
var genericCouponInfo = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCouponInfo = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCouponInfo)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "code";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "expiresOn";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "promotionName";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Calendar_Types_RestaurantLocalDay.showRestaurantLocalDay)))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "CouponInfo";
        }
    }))
};
var unscrambleDecodeCouponInfo = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCouponInfo)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "code";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "expiresOn";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Calendar_Types_RestaurantLocalDay.unscrambleDecodeRestaurantLocalDay))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "promotionName";
        }
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var encodeCouponSource = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericCouponSource)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Manual";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "FirstOrderDiscount";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Loyalty";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Pbx";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "FirstAbsenceReminder";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "SecondAbsenceReminder";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "RosPhoneOrder";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "RosPortalOrder";
        }
    })))))))))
};
var encodePromotionIdForSource = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPromotionIdForSource)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "PromotionIdForSource";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "source";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeCouponSource)))({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Promotions_Types_Id.encodePromotionId)))))))
};
var encodeUsageData = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericUsageData)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "UsageData";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "usedCoupons";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Promotions_Types_Id.encodePromotionId)))({
        reflectSymbol: function () {
            return "marketing";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeCouponSource))))({
        reflectSymbol: function () {
            return "generatedCoupons";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
        reflectSymbol: function () {
            return "activeCoupons";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Coupons_Types_Id.encodeCouponId)))))))
};
var encodeCouponInfo = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCouponInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CouponInfo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "promotionName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "expiresOn";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Calendar_Types_RestaurantLocalDay.encodeRestaurantLocalDay))))({
        reflectSymbol: function () {
            return "code";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))
};
var decodeCouponSource = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericCouponSource)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Manual";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "FirstOrderDiscount";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Loyalty";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Pbx";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "FirstAbsenceReminder";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "SecondAbsenceReminder";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "RosPhoneOrder";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "RosPortalOrder";
        }
    })))))))))
};
var decodePromotionIdForSource = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPromotionIdForSource)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "PromotionIdForSource";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "source";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeCouponSource))())({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Promotions_Types_Id.decodePromotionId1)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeUsageData = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericUsageData)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "UsageData";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "usedCoupons";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Promotions_Types_Id.decodePromotionId1))())({
        reflectSymbol: function () {
            return "marketing";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeCouponSource)))())({
        reflectSymbol: function () {
            return "generatedCoupons";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())({
        reflectSymbol: function () {
            return "activeCoupons";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Coupons_Types_Id.decodeCouponId)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeCouponInfo = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCouponInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "CouponInfo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "promotionName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "expiresOn";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Calendar_Types_RestaurantLocalDay.decodeRestaurantLocalDay)))())({
        reflectSymbol: function () {
            return "code";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    UsageData,
    PromotionIdForSource,
    Manual,
    FirstOrderDiscount,
    Loyalty,
    Pbx,
    FirstAbsenceReminder,
    SecondAbsenceReminder,
    RosPhoneOrder,
    RosPortalOrder,
    CouponInfo,
    genericUsageData,
    eqUsageData,
    showUsageData,
    encodeUsageData,
    decodeUsageData,
    unscrambleDecodeUsageData,
    hasFieldUsageData,
    newtypeUsageData_,
    genericPromotionIdForSource,
    eqPromotionIdForSource,
    showPromotionIdForSource,
    encodePromotionIdForSource,
    decodePromotionIdForSource,
    unscrambleDecodePromotionIdForSource,
    hasFieldPromotionIdForSou,
    newtypePromotionIdForSour,
    genericCouponSource,
    eqCouponSource,
    showCouponSource,
    encodeCouponSource,
    decodeCouponSource,
    unscrambleDecodeCouponSource,
    ordCouponSource,
    enumCouponSource,
    boundedCouponSource,
    boundedEnumCouponSource,
    genericCouponInfo,
    eqCouponInfo,
    showCouponInfo,
    encodeCouponInfo,
    decodeCouponInfo,
    unscrambleDecodeCouponInfo,
    hasFieldCouponInfo,
    newtypeCouponInfo_
};
//# sourceMappingURL=index.js.map
